import { ShoppingBag } from "lucide-react";
import { T } from "@/components/translation/T";
import { StoreLanguageSwitcher } from "./StoreLanguageSwitcher";

interface PremiumFooterProps {
  storeName: string | null;
  languages?: { enabledLanguages: string[]; currentLanguage: string; selectLanguage: (c: string) => void };
}

export function PremiumFooter({ storeName, languages }: PremiumFooterProps) {
  const name = storeName || "Ma Boutique";

  return (
    <footer className="bg-[#111] text-white py-16 px-6 mt-4">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 mb-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-2.5">
              <ShoppingBag className="h-5 w-5 text-white/70" />
              <span className="text-lg font-bold tracking-tight" translate="no">{name}</span>
            </div>
            <p className="text-sm text-white/40 max-w-[280px] leading-relaxed">
              <T>Des produits premium pour un style de vie moderne. Une qualité de confiance.</T>
            </p>
          </div>

          {/* Links */}
          <div className="space-y-4">
            <h4 className="text-xs font-semibold uppercase tracking-widest text-white/50"><T>Liens rapides</T></h4>
            <nav className="flex flex-col gap-2.5">
              {["Boutique", "Produits", "À propos", "Contact"].map((l) => (
                <a key={l} href="#" className="text-sm text-white/60 hover:text-white transition-colors duration-300"><T>{l}</T></a>
              ))}
            </nav>
          </div>

          {/* Support */}
          <div className="space-y-4">
            <h4 className="text-xs font-semibold uppercase tracking-widest text-white/50">Support</h4>
            <nav className="flex flex-col gap-2.5">
              {["FAQ", "Livraison", "Retours", "Politique de confidentialité"].map((l) => (
                <a key={l} href="#" className="text-sm text-white/60 hover:text-white transition-colors duration-300"><T>{l}</T></a>
              ))}
            </nav>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center">
          <p className="text-xs text-white/30">
            © {new Date().getFullYear()} <span translate="no">{name}</span>. <T>Tous droits réservés.</T>
          </p>
          {languages && (
            <StoreLanguageSwitcher
              className="mt-4 text-white/60"
              enabledLanguages={languages.enabledLanguages}
              currentLanguage={languages.currentLanguage}
              onSelect={languages.selectLanguage}
            />
          )}
        </div>
      </div>
    </footer>
  );
}
